import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isLoggedIn } from '../../utils/auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4613/auth';

export const accountsApi = createApi({
  reducerPath: 'accountsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token && isLoggedIn()) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['Accounts'],
  endpoints: (builder) => ({
    getAccounts: builder.query({
      query: (params = {}) => ({
        url: '/accounts',
        method: 'GET',
        params: {
          page: params.page,
          limit: params.limit,
          search: params.search,
        }
      }),
      providesTags: ['Accounts'],
    }),
    
    getAccount: builder.query({
      query: (accountId) => `/accounts/${accountId}`,
      providesTags: (result, error, accountId) => [{ type: 'Accounts', id: accountId }],
    }),
    
    createAccount: builder.mutation({
      query: (accountData) => ({
        url: '/accounts',
        method: 'POST',
        body: accountData,
      }),
      invalidatesTags: ['Accounts'],
    }),
    
    updateAccount: builder.mutation({
      query: ({ id, ...accountData }) => ({
        url: `/accounts/${id}`,
        method: 'PUT',
        body: accountData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Accounts', id },
        'Accounts'
      ],
    }),
    
    deleteAccount: builder.mutation({
      query: (accountId) => ({
        url: `/accounts/${accountId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Accounts'],
    }),
  }),
});

export const {
  useGetAccountsQuery,
  useGetAccountQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useDeleteAccountMutation,
} = accountsApi; 